// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import router from './router'
import Element from 'element-ui'
import store from "./vuex/store"
import axios from 'axios'
import CgTable from '@/components/cg_tabel'
import 'element-ui/lib/theme-chalk/index.css'
import "@/styles/index.scss"
import "@/assets/icon/iconfont.css"
import moment from 'moment'
import global from '@/utils/global'
// import Navigation from 'vue-navigation'
import lodash from 'lodash'
import 'video.js/dist/video-js.css'
import {
  post,
  get,
  del,
  put,
  request
} from '@/utils/request'
//定义全局变量
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$delete = del;
Vue.prototype.$put = put;
Vue.prototype.$request = request;
Vue.prototype.$axios = axios;
Vue.prototype.$_ = lodash;
Vue.prototype.$moment = moment;
Vue.prototype.global = global;
Vue.use(Element)
Vue.use(VueRouter)
Vue.use(CgTable)
// Vue.use(Navigation, {router})
Vue.config.productionTip = false

Vue.directive('has', {
    inserted: function (el, binding) {
      if (!permissionJudge(binding.value)) {
          el.parentNode.removeChild(el);
      }
      function permissionJudge(value) {
          // 此处store.getters.getMenuBtnList代表vuex中储存的按钮菜单数据
          let userMenuButton=localStorage.getItem("userMenuButton"),list=[];
          if(userMenuButton && lodash.isString(userMenuButton)){
            list=Array.isArray(JSON.parse(userMenuButton))?JSON.parse(userMenuButton):[]
          }
          let cIndex=_.findIndex(list,(item)=>item === value);
          return cIndex>=0?true:false;
      }
    }
});

// 防抖函数限制规定 规定时间内之只能点击一次
Vue.directive('debounce', {
    inserted(el) {
        el.addEventListener('click', e => {
            if (!el.disabled) {
                el.disabled = true
                el.style.cursor = 'not-allowed'
                setTimeout(() => {
                el.style.cursor = 'pointer'
                el.disabled = false
                }, 1500)
            }
        })
    }   
})
/*
  <button v-debounce>防抖</button>
*/

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js